module.exports = __webpack_public_path__ + "img/bespoke123_25.9d4cf2ff.jpg";